var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecurring(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.26 23.26"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.63 0a11.63 11.63 0 1011.63 11.63.53.53 0 10-1.06 0 10.41 10.41 0 11-2.45-6.87H17a.53.53 0 100 1h3.69a.52.52 0 00.65-.62V1.48a.52.52 0 00-.52-.54h-.07a.55.55 0 00-.47.54v2.3A11.74 11.74 0 0011.63 0zm-.38 5.49a.53.53 0 00-.46.54v6.23a.5.5 0 00.15.38l3.28 3.28a.53.53 0 00.83-.67l-.05-.08L11.84 12V6a.53.53 0 00-.51-.54z",
    "data-name": "Layer 1"
  }))));
}
export default SvgRecurring;